import React, { useEffect, useState } from "react";
import { Eye, X, ScanLine, Save, AlertTriangle } from "lucide-react";
import { scanUx, highlightCollisions } from "../lib/uxScan";
import api from "../lib/api";
import { toast } from "sonner";

export function isCeoPreview() {
  try { return sessionStorage.getItem("fumaCeoPreview") === "1"; } catch (e) { return false; }
}

export default function CeoPreviewBanner() {
  const [active, setActive] = useState(false);
  const [result, setResult] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("ceoPreview") === "1") {
      try { sessionStorage.setItem("fumaCeoPreview", "1"); } catch (e) {}
    }
    setActive(isCeoPreview());
  }, []);

  if (!active) return null;

  const exit = () => {
    try { sessionStorage.removeItem("fumaCeoPreview"); } catch (e) {}
    window.close();
    window.location.href = "/ceo";
  };

  const runScan = () => {
    const r = scanUx();
    highlightCollisions();
    setResult(r);
    toast(`UX Health ${r.score}/100 · ${r.collisions.length} collisioni · ${r.overflows.length} overflow`);
  };

  const saveAudit = async () => {
    if (!result) return;
    setSaving(true);
    try {
      await api.post("/ceo/ux-audit", result);
      toast.success("Audit salvato — Dashboard CEO › Auto-Audit UX");
    } catch (e) { toast.error("Errore salvataggio audit"); }
    setSaving(false);
  };

  const scoreColor = result ? (result.score >= 80 ? "#00E676" : result.score >= 50 ? "#FFD700" : "#F87171") : "#00E676";

  return (
    <>
      <div data-testid="ceo-preview-banner" className="fixed top-0 left-0 right-0 z-[9999] bg-[#00E676] text-black flex items-center justify-center gap-2 px-3 py-2 text-sm font-semibold shadow-lg">
        <Eye className="h-4 w-4 shrink-0" />
        <span className="truncate hidden sm:inline">Anteprima Cliente</span>
        <button data-testid="ceo-preview-scan" onClick={runScan} className="ml-1 flex items-center gap-1 bg-black text-[#00E676] rounded-full px-3 py-1 shrink-0">
          <ScanLine className="h-3.5 w-3.5" /> Scansiona UX
        </button>
        <button data-testid="ceo-preview-exit" onClick={exit} className="flex items-center gap-1 bg-black/80 text-white rounded-full px-3 py-1 shrink-0">
          <X className="h-3.5 w-3.5" /> Esci
        </button>
      </div>
      <div className="h-9" aria-hidden />

      {result && (
        <div data-testid="ux-scan-result" className="fixed bottom-4 right-4 z-[9999] w-[340px] max-w-[92vw] rounded-2xl bg-[#0F1016] border border-white/15 shadow-2xl p-4 text-white">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 font-display font-bold"><ScanLine className="h-4 w-4 text-[#00E676]" /> Auto-Audit UX</div>
            <button data-testid="ux-scan-close" onClick={() => setResult(null)} className="text-zinc-500"><X className="h-4 w-4" /></button>
          </div>
          <div className="flex items-center gap-3 my-3">
            <div className="text-3xl font-black" style={{ color: scoreColor }}>{result.score}</div>
            <div className="text-xs text-zinc-400">UX Health<br />{result.viewport} · {result.route}</div>
          </div>
          <div className="text-sm space-y-1 max-h-40 overflow-auto">
            <div className="flex items-center gap-1.5 text-zinc-300"><AlertTriangle className="h-3.5 w-3.5 text-amber-400" /> {result.collisions.length} collisioni · {result.overflows.length} overflow</div>
            {result.collisions.slice(0, 6).map((c, i) => (
              <div key={i} className="text-[11px] text-zinc-500 truncate">• {c.a} ↔ {c.b} ({Math.round(c.ratio * 100)}%)</div>
            ))}
          </div>
          <button data-testid="ux-scan-save" onClick={saveAudit} disabled={saving} className="mt-3 w-full flex items-center justify-center gap-1.5 bg-[#00E676] text-black font-semibold rounded-full py-2 text-sm disabled:opacity-60">
            <Save className="h-4 w-4" /> {saving ? "Salvataggio…" : "Salva audit"}
          </button>
        </div>
      )}
    </>
  );
}
